var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"pa-5",attrs:{"type":_vm.getLoaderTemplate()}})
}
var staticRenderFns = []

export { render, staticRenderFns }